import { EExerciseView } from './constants';
import { IExerciseState, statePropName } from './slice';

export interface IAppState {
  // this feature state
  [statePropName]: IExerciseState;
  // other features we don't care of
  [otherKeys: string]: any;
}

const getState = (state: IAppState) => state[statePropName];

export const isLoading = (state: IAppState) => getState(state).loading;

export const getPageView = (state: IAppState) => getState(state).view;

export const isWorkoutRunning = (state: IAppState) => getPageView(state) === EExerciseView.Workout;

export const getWorkoutId = (state: IAppState) => getState(state).workoutId;

export const getWorkoutStartDifficulty = (state: IAppState) => getState(state).startDifficulty;

export const getWorkoutReachedDifficulty = (state: IAppState) => getState(state).reachedDifficulty;

export const getDifficulty = (state: IAppState) => getState(state).difficulty;

export const getLastWorkoutGoal = (state: IAppState) => getState(state).goal;

export const getLastWorkoutScore = (state: IAppState) => getState(state).lastScore;

export const getExerciseRun = (state: IAppState) => getState(state).exerciseRun;

export const isLottiePreloaderVisible = (state: IAppState) => getState(state).unityPreloader;

export const isStaticPreloaderVisible = (state: IAppState) => getState(state).staticPreloader;

export const isWorkoutView = (state: IAppState) => {
  const currentView = getPageView(state);
  return currentView === EExerciseView.Workout;
};

export const getLedView = (state: IAppState) => getState(state).led;

export const getExerciseMode = (state: IAppState) => getState(state).exerciseMode;
